<nav class="legal-toc" [class.legal-toc--open]="open"
  [attr.aria-label]="heading() || ('mainauth.legalToc.heading' | translate)">
  <!-- Narrow screens only: the sidebar becomes a collapsible card above the content. -->
  <button type="button" class="legal-toc__toggle" (click)="open = !open" [attr.aria-expanded]="open">
    <ion-icon name="list-outline"></ion-icon>
    <span>{{ heading() || ('mainauth.legalToc.heading' | translate) }}</span>
    <ion-icon class="legal-toc__chevron" name="chevron-down-outline"></ion-icon>
  </button>

  <div class="legal-toc__title">{{ heading() || ('mainauth.legalToc.heading' | translate) }}</div>

  <div class="legal-toc__list">
    @for (group of groups(); track $index) {
    <section class="legal-toc__group">
      <!-- One heading per product / the general block; jumps to the product's header card. -->
      @if (group.label || group.labelKey) {
      <button type="button" class="legal-toc__group-title" (click)="scrollToId(group.target!); open = false">
        {{ group.label || (group.labelKey! | translate) }}
      </button>
      }
      <ul>
        @for (section of group.sections; track section.id) {
        <li>
          <button type="button" class="legal-toc__item" [class.legal-toc__item--active]="activeId === section.id"
            (click)="scrollTo(section)">
            <span class="legal-toc__num">{{ section.num }}</span>
            <!-- Product documents carry their heading as plain text (fr/it are not in the
                 translation files); the base pages still resolve it from an i18n key. -->
            @if (section.title) {
            <span class="legal-toc__label">{{ section.title }}</span>
            } @else {
            <span class="legal-toc__label">{{ section.titleKey | translate }}</span>
            }
          </button>
        </li>
        }
      </ul>
    </section>
    }
  </div>
</nav>
